import {
	ExarePriceDetailsGroupFragment,
	ExarePriceDetailsPriceElementType,
	RefundPricesFragment
} from '@websky/graphql';

export const isFareOrServicesNotEmpty = (refunded: ExarePriceDetailsGroupFragment) =>
	refunded.elements.some(
		element =>
			element.type === ExarePriceDetailsPriceElementType.fare ||
			element.type === ExarePriceDetailsPriceElementType.gdsServiceFare
	);

export const isRetentionNotEmpty = (prices: RefundPricesFragment) =>
	prices.priceDetails.retention?.elements?.length > 0;
